module.exports = __webpack_public_path__ + "media/images/companies/hvc-c121c28621194761eebe0fa0d8548c2f.png";